// extracted by mini-css-extract-plugin
export default {"qa_qas":"QA_qa_qas__B3cxw","qa_header":"QA_qa_header__uvCt9"};